export const RESERVED_NAMES = ['pushbot', 'admin', 'owner', 'public', 'me'];
const RESERVED_NAME_PATTERN = new RegExp(
  `^(${RESERVED_NAMES.join('|')})$`,
  'i'
);
const CLEAN_EMAIL = /(@.*|[^0-9a-z_]*)/g;

export const usernameFromEmail = email => email.replace(CLEAN_EMAIL, '');
export const isReservedName = value => RESERVED_NAME_PATTERN.test(value);



// WEBPACK FOOTER //
// ./js/util/username.js